export class SimpleMutex {
  private queue: Array<{
    reject: (reason?: Error) => void;
    resolve: () => void;
    timeoutId: NodeJS.Timeout;
  }> = [];
  private locked = false;
  private readonly DEFAULT_TIMEOUT_MS = 30000; // 30 seconds

  public async runExclusive<T>(fn: () => Promise<T> | T): Promise<T> {
    while (this.locked) {
      await new Promise<void>((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          const index = this.queue.findIndex(
            (item) => item.resolve === resolve,
          );
          if (index !== -1) {
            this.queue.splice(index, 1);
          }
          reject(new Error('Mutex lock timeout exceeded'));
        }, this.DEFAULT_TIMEOUT_MS);

        this.queue.push({ resolve, reject, timeoutId });
      });
    }

    this.locked = true;
    try {
      return await fn();
    } finally {
      this.locked = false;
      const next = this.queue.shift();
      if (next) {
        clearTimeout(next.timeoutId);
        next.resolve();
      }
    }
  }

  public cleanup(): void {
    while (this.queue.length > 0) {
      const next = this.queue.shift();
      if (next) {
        clearTimeout(next.timeoutId);
        next.reject(new Error('Mutex cleanup called'));
      }
    }
    this.locked = false;
  }
}
